module.exports = "/resources/assets/prod/3b0410e5f347cf3264c6cbdeeb283e6a.svg";